import { render, staticRenderFns } from "./SchoolNotification.vue?vue&type=template&id=8abaede6"
import script from "../../services/notification/school-notification.js?vue&type=script&lang=js&external"
export * from "../../services/notification/school-notification.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/notification/school-notification.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports